import React from 'react';

const AddEpisode = () => {
  return (
    <div className="addepisode-page">
      <h1>Add Episode</h1>
      <p>This is a dummy add episode page. Will be converted from Vue component.</p>
      <div className="page-content">
        <div className="placeholder-content">
          <h2>Placeholder Content</h2>
          <p>This page will be implemented with full functionality during the conversion process.</p>
          <div className="action-buttons">
            <button className="btn btn-primary">Primary Action</button>
            <button className="btn btn-secondary">Secondary Action</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEpisode;